type Props = {
  className?: string
}

export const Skeleton = ({ className = '' }: Props) => (
  <div
    className={`animate-pulse rounded-md bg-app-subtle ${className}`}
    aria-hidden="true"
  />
)

